import { bindModalAction, createModalOverlay } from './modalBase';
import { isMacPlatform } from '../../input/shortcuts';

export const showShortcutsModal = (_mode?: string): void => {
  const isMac = isMacPlatform();
  const mod = isMac ? '⌘' : 'Ctrl';
  const deleteKey = isMac ? 'Delete' : 'Del';

  const shortcuts = `
    <div class="shortcut-group">
      <h4>Tools</h4>
      <div class="shortcut-row"><kbd>V</kbd><span>Select tool</span></div>
      <div class="shortcut-row"><kbd>P</kbd><span>Pen tool</span></div>
      <div class="shortcut-row"><kbd>E</kbd><span>Eraser tool</span></div>
      <div class="shortcut-row"><kbd>T</kbd><span>Text tool</span></div>
      <div class="shortcut-row"><kbd>R</kbd><span>Rectangle</span></div>
      <div class="shortcut-row"><kbd>O</kbd><span>Ellipse</span></div>
      <div class="shortcut-row"><kbd>D</kbd><span>Diamond</span></div>
      <div class="shortcut-row"><kbd>G</kbd><span>Triangle</span></div>
      <div class="shortcut-row"><kbd>L</kbd><span>Connector</span></div>
      <div class="shortcut-row"><kbd>Space</kbd><span>Hold to pan</span></div>
    </div>
    <div class="shortcut-group">
      <h4>View</h4>
      <div class="shortcut-row"><kbd>${mod} +</kbd><span>Zoom in</span></div>
      <div class="shortcut-row"><kbd>${mod} -</kbd><span>Zoom out</span></div>
      <div class="shortcut-row"><kbd>${mod} 0</kbd><span>Reset zoom</span></div>
      <div class="shortcut-row"><kbd>G</kbd><span>Toggle grid</span></div>
      <div class="shortcut-row"><kbd>S</kbd><span>Toggle snap to grid</span></div>
      <div class="shortcut-row"><kbd>I</kbd><span>Invert canvas</span></div>
    </div>
    <div class="shortcut-group">
      <h4>Edit</h4>
      <div class="shortcut-row"><kbd>${mod} Z</kbd><span>Undo</span></div>
      <div class="shortcut-row"><kbd>${mod} Shift Z</kbd><span>Redo</span></div>
      <div class="shortcut-row"><kbd>${mod} C</kbd><span>Copy</span></div>
      <div class="shortcut-row"><kbd>${mod} V</kbd><span>Paste</span></div>
      <div class="shortcut-row"><kbd>${deleteKey}</kbd><span>Delete selected</span></div>
    </div>
    <div class="shortcut-group">
      <h4>Other</h4>
      <div class="shortcut-row"><kbd>${mod} S</kbd><span>Save project</span></div>
      <div class="shortcut-row"><kbd>?</kbd><span>Show shortcuts</span></div>
    </div>
  `;

  const { overlay, close } = createModalOverlay(`
    <div class="modal-content shortcuts-modal">
      <h3 class="modal-title">Keyboard Shortcuts</h3>
      <div class="shortcuts-grid">
        ${shortcuts}
      </div>
      <div class="modal-actions">
        <button class="modal-btn modal-btn-cancel">Close</button>
      </div>
    </div>
  `);

  bindModalAction(overlay, '.modal-btn-cancel', close);
};
